import { Box as MuiBox, Grid as MuiGrid } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

const DEFAULT_ACCEPT = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg", ".jpg"],
  "image/gif": [".gif"],
  "image/tiff": [".tiff", ".tif"],
  "application/pdf": [".pdf"],
  "text/plain": [".txt"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.ms-outlook": [".msg"],
};

export const DropZone = (props) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps } = useDropzone({
    accept: props.acceptedFiles ? props.acceptedFiles : DEFAULT_ACCEPT,
    multiple: false,
    maxFiles: 1,
    onDropAccepted: (droppedFiles, event) => {
      props.handleDrop?.(droppedFiles, event);
      props.handleDocumentUpload?.(droppedFiles);
    },
    onDropRejected: (fileRejections, event) => {
      props.handleDropRejected?.(
        fileRejections.map((rejection) => rejection.file),
        event,
      );
    },
  });

  return (
    <MuiBox
      sx={{
        "& .MuiBox-root": {
          width: "100%",
          display: "flex",
          minHeight: "80px",
          flexDirection: "column",
        },
        "& .MuiSvgIcon-root": {
          display: "none",
        },
        "& .MuiTypography-root": {
          fontSize: "14px",
          whiteSpace: "pre-line",
        },
        "& .MuiSvgIcon-root ~ .MuiTypography-root": {
          whiteSpace: "nowrap",
        },
      }}
    >
      <MuiGrid
        sx={{
          width: "100%",
          "& .dropzone-root": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "79px",
            border: "1px dashed #c6c6c6",
            borderRadius: "5px",
            padding: "8px 16px",
            cursor: "pointer",
            outline: "none",
          },
          "& .dropzone-root:focus-visible": {
            borderColor: "#1976d2",
          },
          "& .dropzone-text": {
            width: "100%",
            textAlign: "center",
          },
          "& .dropzone-text .MuiTypography-root": {
            fontSize: "14px",
            whiteSpace: "pre-line",
          },
        }}
      >
        <MuiGrid {...getRootProps({ className: "dropzone-root" })}>
          <input {...getInputProps()} />
          <MuiGrid wrap="wrap" className="dropzone-text">
            {props.dropzoneText ||
              t(
                "Commitments.commitmentDocuments.create.form.fields.uploadedDocument.label",
              )}
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
